import React from 'react';
import { CalendarDays } from 'lucide-react';
import { Tutor } from '../data/tutors';
import { openTutorCalendly, rememberPreferredTutor } from '../services/booking';
import '../styles/Tutors.css';

interface TutorCardProps {
  tutor: Tutor;
  /** Booking unlocked (post-payment) or marketing view. */
  bookable?: boolean;
  revealDelay?: number;
}

const TutorCard: React.FC<TutorCardProps> = ({ tutor, bookable = false, revealDelay = 0 }) => {
  return (
    <article
      className="tutor-card bracketed"
      data-reveal
      style={{ ['--reveal-delay' as string]: `${revealDelay}s` }}
    >
      <div className="tutor-head">
        <span className={`monogram monogram-${tutor.branch}`} aria-hidden="true">
          {tutor.initials}
        </span>
        <div>
          <h3 className="tutor-role">{tutor.role}</h3>
          <p className="tutor-seat">{tutor.seat}</p>
        </div>
      </div>

      <ul className="tutor-facts">
        {tutor.facts.map(fact => (
          <li key={fact}>{fact}</li>
        ))}
      </ul>

      {bookable ? (
        <button className="btn btn-primary tutor-book" onClick={() => openTutorCalendly(tutor)}>
          Lock in a time with {tutor.initials}
        </button>
      ) : (
        <div className="tutor-preview">
          <button
            className="btn btn-ghost tutor-availability"
            onClick={() => {
              rememberPreferredTutor(tutor.id);
              openTutorCalendly(tutor);
            }}
          >
            <CalendarDays size={14} aria-hidden="true" />
            Check availability
          </button>
        </div>
      )}
    </article>
  );
};

export default TutorCard;
